import { render, staticRenderFns } from "./networkStudentList.vue?vue&type=template&id=1d832732&scoped=true&"
import script from "./networkStudentList.vue?vue&type=script&lang=js&"
export * from "./networkStudentList.vue?vue&type=script&lang=js&"
import style0 from "./networkStudentList.vue?vue&type=style&index=0&id=1d832732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d832732",
  null
  
)

export default component.exports